<template>
<div class="my">
  <div class="cont">
  <!-- 关于我们 -->
    <div class="title" >
    <div class="p1">
      <img src="../assets/img/s-back.png" alt="">
    </div>
    <div class="p2">
      <img src="../assets/img/s-back.png" alt="">
    </div>
      <div>
        <div class="box1"></div>
        <div class="box2" style=" font-size: 1.456rem;">关于我们</div>
      </div>
      <div class="title_b">
        <div class="title_o"><img src="../assets/img/my1.png" alt=""></div>
        <div style="line-height: 1.664rem; margin-top: 2.08rem;">
          <p style="margin-bottom: 5.02rem; font-size: 0.832rem;">企鹅智慧，是由企鹅互动研发的智慧商业应用平台，是一个领先的实体商业智慧运营服务平台。服务包括互动营销、会员管理、会员服务、线上商城、大数据监控、消费者BI等功能。通过移动端会员应用+会员数据服务为商场/购物中心提供“商业地产新零售”整体解决方案。产品自上线以来，服务了包括五环体育、印象城，阳光天地，悦秀城、MOMOPARK等众多商业综合体，以模块+定制的服务模式为各大商业中心提供独一无二的个性化智慧零售平台应用。目前，企鹅智慧已成为腾讯智慧零售ISV产品。已实现包括科传、长益、富基、商通、ETCP、迅捷、立方、停车王等在内的多家商业管理服务软件集成。</p>
        </div>
        <div class="title_s"><img src="../assets/img/my2.png" alt=""></div>
        <div style="line-height:1.664rem;margin-top: 2.08rem; font-size: 0.832rem;">
          <p>企鹅互动（PIBC），是基于互联网腾讯主流媒体广告产品及腾讯智慧零售产品，为企业提供互联网品牌整合推广、智慧商业产品解决方案，并进行深度定制的互联网公司。</p>
          <p>团队核心成员来自于腾讯前员工、北京及陕西的互联网公司。深入行业品牌整合、互联网区域化产品领域，团队实现诸多全国优秀品牌企业的新媒体整合营销案例，负责多个本地知名产品平台的创立、规划、开发、运营和市场推广。</p>
        </div>
      </div>
    </div>
  </div>
    <!-- 底部 -->
    <div class="food">
      <div class="food_t" style="20px">
        <div class="food_l">
          <p>ADRESS：</p>
          <p>陕西省西安市雁塔区雁塔南路885号西安金辉环球广场</p>
        </div>
        <div class="food_r">
          <div>联系我们：</div>
          <div><img style="width: 100%;" src="../assets/img/erm.jpg" alt=""></div>
        </div>
      </div>
      <div class="food_b" style="font-size: 0.832rem;">Copyright © 2018 企鹅互动网络版权所有[官方网站]   <a style="color:#FFF;" href="https://beian.miit.gov.cn/" target="_blank">陕ICP备16018502号-2</a></div>
    </div>

</div>
</template>
<script>
export default {
  name: "my",
  data () {
    return {

    };
  }
}
</script>
<style scoped>
/* .partner{
    min-width: 1250px;
  } */

  html{
    font-size:1vw;
  }

.cont{
  width: 61%;
  margin: 0 21%;
  margin-top: -2.704rem;
}
.cont>div{
  width: 100%;
}
.box1{
  width: 36%;
  height: 2px;
  background: #FFCE00;
}
.box2{
  font-size: 1.144rem;
  font-weight: bold;
  margin: 1.144rem 0 2.08rem 0;;
}
/* 经典案例 */
.title_b{
  width: 100%;
}
.title_o{
  width: 24.6%;
}
.title_o>img{
  width: 100%;
}
.title_s{
  width: 35%;
}
.title_s>img{
  width: 100%;
}


/* 漂浮 */
 .p1{
      width: 34%;
      height: 10.92rem;
      position: absolute;
      left: -8.06rem;
      margin-top: 21.32rem;
      z-index: -1;
  }
  .p1>img{
    width: 100%;
  }
  .p2{
      width: 34%;
      height: 17.16rem;
      position: absolute;
      margin-top: 27.54rem;
      right: 0;
      overflow: hidden;
      z-index: -10;
  }
  .p2>img{
    width: 100%;
    position: absolute;
    right:-13.312rem ;
  }
/* 底部 */
.food{
  width: 100%;
  height: 11.596rem;
  background: #333333;
  color: #FFFFFF;
  margin-top: 1.04rem;
}
.food_t{
  width: 58%;
  margin: 0 21%;
  padding-top: 2.132rem;
}
.food_t>div{
  display: inline-block;
  vertical-align: middle;
}
.food_b{
  text-align: center;
}
.food_l{
      margin-top: 1.04rem;
      line-height: 1.56rem;
}
.food_r{
  float: right;
}
.food_r>div{
  display: inline-block;
  vertical-align: middle;
}
.food_r>div:nth-child(2){
  width: 5.72rem;
  height: 5.72rem;
  background: #FFFFFF;
  border-radius: 10px;
}
.food_b{
  margin-top: 2.132rem;
  font-size: 0.624rem;
}

</style>



// WEBPACK FOOTER //
// src/components/my.vue